import script from "./ConditionsGeneralesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConditionsGeneralesPage.vue?vue&type=script&setup=true&lang=ts"

import "./ConditionsGeneralesPage.vue?vue&type=style&index=0&id=e734440e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e734440e"]])

export default __exports__